import { render, staticRenderFns } from "./FormulaQnaDetail.vue?vue&type=template&id=0e46fd4f"
import script from "./FormulaQnaDetail.vue?vue&type=script&lang=js"
export * from "./FormulaQnaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports